import { RecordConversation } from './RecordConversation';
import { StreamingRecordConversation } from './StreamingRecordConversation';
import { useStreamingTranscriptionContext } from './StreamingTranscriptionContext';
import { useTranscriptionRecordingContext } from './TranscriptionRecordingContext';

export function RecordingBanner() {
	const transcriptionRecordingContext = useTranscriptionRecordingContext();
	const streamingContext = useStreamingTranscriptionContext();

	if (streamingContext.state.session && !transcriptionRecordingContext.activeSession) {
		return <StreamingRecordConversation />;
	}

	const {
		activeSession,
		state,
		language,
		setLanguage,
		countdown,
		uploadError,
		pendingRetry,
		retryUploadLoading,
		elapsed,
		bars,
		current,
		stopRecording,
		cancelRecording,
		dismissError,
		retryUpload,
		saveRecordingLocally,
	} = transcriptionRecordingContext;

	return (
		<RecordConversation
			label={activeSession?.label}
			targetPath={activeSession?.targetPath}
			state={state}
			language={language}
			onLanguageChange={setLanguage}
			countdown={countdown}
			uploadError={uploadError}
			canRetryUpload={!!pendingRetry}
			retryUploadLoading={retryUploadLoading}
			onRetryUpload={() => {
				void retryUpload();
			}}
			onSaveRecordingLocally={saveRecordingLocally}
			elapsed={elapsed}
			bars={bars}
			current={current}
			onStop={stopRecording}
			onCancel={cancelRecording}
			onDismissError={dismissError}
		/>
	);
}
